import { MUITab } from "@abb/arcadia-ui-react"
import { useHashTab } from "../../../hooks/useHashTab"
import { KeyValuePairs } from "./keyValuePairs_tab/KeyVaulePairs"

export function ProductionsContainer() {
  const { activeTab, handleTabChange } = useHashTab("keyValuePairs")

  return (
    <div>
      <MUITab
        tabItems={[{ id: "keyValuePairs", label: "Key Value Pairs" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "keyValuePairs" && <KeyValuePairs />}
    </div>
  )
}
